import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
// using Bootstrap Icons instead of FontAwesome
import './Videos.css';
import { videos as allVideos } from '../../data/videos';

// Get unique categories for filter
const categories = ['All', ...new Set(allVideos.map(video => video.category))];

const Videos = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortBy, setSortBy] = useState('date');

  // Filter and sort videos
  const filteredVideos = allVideos
    .filter(video => {
      const matchesSearch = video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         video.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === 'All' || video.category === selectedCategory;
      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      if (sortBy === 'date') {
        return new Date(b.date) - new Date(a.date);
      } else if (sortBy === 'views') {
        return parseInt(b.views) - parseInt(a.views);
      } else if (sortBy === 'duration') {
        return parseFloat(b.duration) - parseFloat(a.duration);
      }
      return 0;
    });

  return (
    <div className="videos-page py-5">
      <Container>
        <h1 className="mb-4">Videos</h1>
        
        {/* Search and Filter Section */}
        <div className="mb-4">
          <Row className="g-3">
            <Col md={6} lg={4}>
              <div className="search-box">
                <Form.Control
                  type="text"
                  placeholder="Search videos..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button variant="outline-secondary"><i className="bi bi-search"></i></Button>
              </div>
            </Col>
            <Col md={4} lg={3}>
              <Form.Select 
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categories.map(category => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4} lg={3}>
              <Form.Select 
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="date">Sort by Date</option>
                <option value="views">Sort by Views</option>
                <option value="duration">Sort by Duration</option>
              </Form.Select>
            </Col>
            <Col md={2} className="d-grid">
              <Button 
                variant="outline-secondary" 
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCategory('All');
                  setSortBy('date');
                }}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </div>

        {/* Videos Grid */}
        {filteredVideos.length > 0 ? (
          <Row xs={1} md={2} lg={3} className="g-4">
            {filteredVideos.map((video) => (
              <Col key={video.id}>
                <Card className="h-100 video-card">
                  <div className="video-thumbnail">
                    <img 
                      src={video.thumbnail} 
                      className="card-img-top" 
                      alt={video.title}
                    />
                    <div className="duration-badge">
                      {video.duration}
                    </div>
                    <div className="play-icon">
                      <i className="bi bi-play-circle-fill"></i>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <span className="badge bg-primary">{video.category}</span>
                      <small className="text-muted"><i className="bi bi-calendar3 me-1"></i>{new Date(video.date).toLocaleDateString('en-IN')}</small>
                    </div>
                    <Card.Title className="h5">{video.title}</Card.Title>
                    <Card.Text className="text-muted">
                      {video.description}
                    </Card.Text>
                    <div className="d-flex justify-content-between align-items-center mt-auto">
                      <small className="text-muted"><i className="bi bi-clock me-1"></i>{video.duration}</small>
                      <small className="text-muted">
                        {video.views} views
                      </small>
                    </div>
                  </Card.Body>
                  <Card.Footer className="bg-transparent border-top-0">
                    <a 
                      href={`https://www.youtube.com/watch?v=${video.videoId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-danger w-100"
                    >
                      Watch on YouTube
                    </a>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="text-center py-5">
            <h3>No videos found matching your criteria.</h3>
            <p className="text-muted">Try adjusting your search or filter to find what you're looking for.</p>
            <Button 
              variant="outline-primary"
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('All');
              }}
            >
              Clear Filters
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Videos;
